import { render } from "./CatalogPrices.vue?vue&type=template&id=690e9728"
import script from "./CatalogPrices.vue?vue&type=script&lang=js"
export * from "./CatalogPrices.vue?vue&type=script&lang=js"

import "./CatalogPrices.vue?vue&type=style&index=0&id=690e9728&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__